const breakpoints = {
    xs: 0,
    sm: 900,
    md: 1200,
    lg: 1630,
    xl: 2160,
};

export default breakpoints;
